import React, { useEffect, useState } from "react";
import { useToasts } from "react-toast-notifications";
import { components } from "react-select";
import Select from "react-select";
import {
    Button,
    Col,
    Form,
    FormGroup,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    Spinner,
} from "reactstrap";
import { MDBCol, MDBIcon } from "mdbreact";
import { api } from "../../services/api";
import {
    retailer_assignment_overrides_states_list,
    Central_CA_TL_TX_NY_DC,
    East_CA_IL_TX,
    East_CA_IL_TX_NY_DC,
    East_CA_NY_DC,
    East_IL_TX_NY_DC,
    West_CA_IL_TX,
    West_CA_IL_TX_NY_DC,
    West_CA_NY_DC,
    West_IL_TX_NY_DC,
    All_SPEAKEASY_STATES,

} from "../../utils/states";
import { GetStateObjectFromStateCode } from "utils/states";
import { CustomMultiSelectDropdown } from "components/CustomDropdown/CustomDropdown";

const MultiValue = (props) => {
  let labelToBeDisplayed = `${props.data.label}, `;
  if (props.data.value === "__all__") {
    labelToBeDisplayed = "All states are selected";
  }
  return (
    <components.MultiValue {...props}>
      <span>{labelToBeDisplayed}</span>
    </components.MultiValue>
  );
};

const ValueContainer = ({ children, ...props }) => {
  const currentValues = props.getValue();
  alert(currentValues);
  let toBeRendered = children;
  if (currentValues.some((val) => val.value === "__all__")) {
    toBeRendered = [[children[0][0]], children[1]];
  }

  return (
    <components.ValueContainer {...props}>
      {toBeRendered}
    </components.ValueContainer>
  );
};

export function ProductsSearchForm({ url, toggle, isOpen, loading, formData }) {
  // This component is being re-used on 2 pages, orders page, retailer-override
  const GetChannelObjectFromChannelId = (channelId) => {
    return OrderChannel_list?.filter((channelObject) => channelObject.id === channelId)[0];
  }
  
  const [isLoading, setLoading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [selectedState, setselectedState] = useState([]);
  const [selectedChannel, setselectedChannel] = useState([]);

  const product_variant_list = [];
  const { addToast } = useToasts();
  const [data, setData] = useState({
    results: [],
    count: 0,
    next: null,
    previous: null,
  });
  const [paramsFilter, setParamsFilter] = useState({});
  const [inventory_location, setInventory_location] = useState("");
  const [InventoryLocation_list, setInventoryLocationlist] = useState([]);
  const [selectedStateDropdownValue, setselectedStateDropdownValue] = useState( formData ? [GetStateObjectFromStateCode(formData.state)] : []);
  const [selectedChannelDropdownValue, setselectedChannelDropdownValue] = useState( formData ? [GetChannelObjectFromChannelId(formData.channel)] : []);
  const [stateIsValid, setStateIsValid] = useState(true);
  const [channelIsValid, setChannelIsValid] = useState(true);
  const [OrderChannel_list, setOrderChannel_list] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    // set default sales channel when this component is getting called from orders page
    if ((OrderChannel_list.length>0) && (formData?.retailer_override_through_order_page)){
      setselectedChannel(formData.channel);
      setselectedChannelDropdownValue(GetChannelObjectFromChannelId(formData.channel[0]));
    }
  },[OrderChannel_list])
  useEffect(() => {
    let customParams;

      getInventoryLocation();
      getOrderChannelList();
    if (formData) {
      setselectedState([GetStateObjectFromStateCode(formData.state)?.value]);
      if (!formData?.retailer_override_through_order_page){
        setselectedChannel([GetChannelObjectFromChannelId(formData.channel).value]);
      }

      // Select invengory location by default If inventory location is passed 
      if (formData?.inventory_location !== "") {
        setInventory_location(formData.inventory_location);
      }

      customParams = {
        variant_skus : formData.variant
      };
    } 

    api
      .get(url, {
        params: formData && !paramsFilter.search ? customParams : paramsFilter,
    })
    .then((response) => {
      setData(response.data);
      if (formData){
        let variantsList = [];
        response.data.results.forEach((product) => {
          product.variants.forEach((variant) => {
            if (customParams.variant_skus.includes(variant["sku"])) {
              variantsList.push(parseInt(variant.id));
            }
          })
        })
        setSelectedProduct(variantsList);
      }
      })
      .catch((error) => console.log(error));
  }, [paramsFilter]);

  //Monday ID- 8333585692 
  const additional_options = [
    { value: "All Speakeasy States", code: "__All_SPEAKEASY_STATES__", label: "All Speakeasy States"},
    { value: "East (CA + NY/DC)", code: "__East_CA_NY_DC__", label: "East (CA + NY/DC)"},
    { value: "West (CA + NY/DC)", code: "__West_CA_NY_DC__", label: "West (CA + NY/DC)"},
    { value: "East (CA + IL/TX + NY/DC)", code: "__East_CA_IL_TX_NY_DC__", label: "East (CA + IL/TX + NY/DC)"},
    { value: "West (CA + IL/TX + NY/DC)", code: "__West_CA_IL_TX_NY_DC__", label: "West (CA + IL/TX + NY/DC)"},
    { value: "Central (CA + IL/TX + NY/DC)", code: "__Central_CA_TL_TX_NY_DC__", label: "Central (CA + IL/TX + NY/DC)"},
    { value: "East (IL/TX + NY/DC)", code: "__East_IL_TX_NY_DC__", label: "East (IL/TX + NY/DC)"},
    { value: "West (IL/TX + NY/DC)", code: "__West_IL_TX_NY_DC__", label: "West (IL/TX + NY/DC)"},
    { value: "East (CA + IL/TX)", code: "__East_CA_IL_TX__", label: "East (CA + IL/TX)"},
    { value: "West (CA + IL/TX)", code: "__West_CA_IL_TX__", label: "West (CA + IL/TX)"},
  ]
  //Monday ID- 8333585692 

  useEffect(() => {
    retailer_assignment_overrides_states_list.splice(1,0,...additional_options);
  },[])

  let timer = null;
  
  const getOrderChannelList = () => {
    // To fetch the channels list for sales channel dropdown when the page initially loads the first time
    api
      .get(`order/channel-list-api/`)
      .then((response) => response)
      .then((response) => {
        if (response.status === 200) {
          let channels = [{
            id: "__all__",
            label: "Select All",
            value: "__all__",
        }];
          let finalResult = channels.concat(response.data);
          setOrderChannel_list(finalResult);
        }
      })
      .catch((err) => {
        console.error();
      });
  };

  const handleSearch = (e) => {
    // limpamos o timer
    clearTimeout(timer);
    // armazenamos o timer novamente
    timer = setTimeout(function () {
      setParamsFilter({
        ...paramsFilter,
        search: e.target.value,
      });
    }, 750);
  };

  const handleProductCheckbox = (e, product_id) => {
    if (selectedProduct.length <= 0) {
      let checkbox = document.querySelectorAll(".variant_" + product_id);
      for (let i = 0; i < checkbox.length; i++) {
        if (e.target.checked === true && checkbox[i].checked === false) {
          checkbox[i].checked = true;
        }
        if (e.target.checked === false && checkbox[i].checked === true) {
          checkbox[i].checked = false;
        }
        if (e.target.checked === false) {
          checkbox[i].checked = false;
        }
        if (
          e.target.checked === true &&
          product_variant_list.includes(parseInt(product_id)) === false
        ) {
          setSelectedProduct(product_variant_list);
        }
        for (let i = 0; i < checkbox.length; i++) {
          if (e.target.checked === true) {
            if (
              product_variant_list.includes(parseInt(checkbox[i].value)) ===
              false
            ) {
              product_variant_list.push(parseInt(checkbox[i].value));
              setSelectedProduct(product_variant_list);
            }
          }
        }
      }
    } else if (selectedProduct.length > 0) {
      if (e.target.checked === false) {
        let remove_checkbox = document.querySelectorAll(
          ".variant_" + product_id
        );
        for (let i = 0; i < remove_checkbox.length; i++) {
          remove_checkbox[i].checked = false;
          var removeVariantIdIndex = selectedProduct.indexOf(
            parseInt(remove_checkbox[i].value)
          );
          if (removeVariantIdIndex !== -1) {
            selectedProduct.splice(removeVariantIdIndex, 1);
            setSelectedProduct(selectedProduct);
          }
          setSelectedProduct(selectedProduct);
        }
      } else if (e.target.checked === true) {
        var new_product_variant_list = [];
        new_product_variant_list = selectedProduct;
        var productIdIndex = new_product_variant_list.indexOf(product_id);
        if (productIdIndex !== -1) {
          new_product_variant_list.splice(productIdIndex, 1);
        }
        let checkbox = document.querySelectorAll(".variant_" + product_id);
        for (let i = 0; i < checkbox.length; i++) {
          if (e.target.checked === true && checkbox[i].checked === false) {
            checkbox[i].checked = true;
          }
          if (e.target.checked === false && checkbox[i].checked === true) {
            checkbox[i].checked = false;
            var checkboxproductIdIndex = new_product_variant_list.indexOf(
              checkbox[i].value
            );
            if (productIdIndex !== -1) {
              new_product_variant_list.splice(checkboxproductIdIndex, 1);
            }
            setSelectedProduct(new_product_variant_list);
          }
          if (
            e.target.checked === true &&
            new_product_variant_list.includes(parseInt(product_id)) === false
          ) {
            setSelectedProduct(new_product_variant_list);
          }
          for (let i = 0; i < checkbox.length; i++) {
            if (e.target.checked === true) {
              if (
                new_product_variant_list.includes(
                  parseInt(checkbox[i].value)
                ) === false
              ) {
                new_product_variant_list.push(parseInt(checkbox[i].value));
                setSelectedProduct(new_product_variant_list);
              }
            }
          }
        }
      }
    }
  };

  const handleVariantProductCheckbox = (e, variant_id) => {
    var new_product_variant_list = [];
    if (selectedProduct.length > 0) {
      var myIndex = selectedProduct.indexOf(variant_id);
      if (myIndex !== -1) {
        selectedProduct.splice(myIndex, 1);
      } else {
        new_product_variant_list = selectedProduct;
        new_product_variant_list.push(parseInt(variant_id));
        setSelectedProduct(new_product_variant_list);
      }
    } else {
      new_product_variant_list = selectedProduct;
      new_product_variant_list.push(parseInt(variant_id));
      setSelectedProduct(new_product_variant_list);
    }
  };

  const handleChange = (selected) => {
    let isSelectAll = selected.some((state) => state.value === "__all__");
  
    if (isSelectAll) {
      setselectedState("__all__");
      setselectedStateDropdownValue(retailer_assignment_overrides_states_list.filter((state) => state.value !== "__all__" && state.value !== "East (CA + NY/DC)" && state.value !== "West (CA + NY/DC)" && state.value !== "East (CA + IL/TX + NY/DC)" && state.value !== "West (CA + IL/TX + NY/DC)" && state.value !== "Central (CA + IL/TX + NY/DC)" && state.value !== "East (IL/TX + NY/DC)" && state.value !== "West (IL/TX + NY/DC)" && state.value !== "East (CA + IL/TX)" && state.value !== "West (CA + IL/TX)" && state.value !== "Michigan" && state.value !== "Massachusetts"))
    } else {
      let new_state_list = [];
      let newDropdownValue = [];
  
      selected.forEach((event) => {
        //Monday ID- 8333585692 
        if (event.value === "East (CA + NY/DC)") {
          new_state_list.push(...East_CA_NY_DC.map((state) => state.value));
          newDropdownValue = newDropdownValue.concat(East_CA_NY_DC);
        } else if (event.value === "West (CA + NY/DC)") {
          new_state_list.push(...West_CA_NY_DC.map((state) => state.value));
          newDropdownValue = newDropdownValue.concat(West_CA_NY_DC);
        } else if(event.value === "East (CA + IL/TX + NY/DC)"){
          new_state_list.push(...East_CA_IL_TX_NY_DC.map((state) => state.value));
          newDropdownValue = newDropdownValue.concat(East_CA_IL_TX_NY_DC);
        }else if(event.value === "West (CA + IL/TX + NY/DC)"){
          new_state_list.push(...West_CA_IL_TX_NY_DC.map((state) => state.value));
          newDropdownValue = newDropdownValue.concat(West_CA_IL_TX_NY_DC);
        }else if(event.value === "Central (CA + IL/TX + NY/DC)"){
          new_state_list.push(...Central_CA_TL_TX_NY_DC.map((state) => state.value));
          newDropdownValue = newDropdownValue.concat(Central_CA_TL_TX_NY_DC);
        }else if(event.value === "East (IL/TX + NY/DC)"){
          new_state_list.push(...East_IL_TX_NY_DC.map((state) => state.value));
          newDropdownValue = newDropdownValue.concat(East_IL_TX_NY_DC);
        }else if(event.value === "West (IL/TX + NY/DC)"){
          new_state_list.push(...West_IL_TX_NY_DC.map((state) => state.value));
          newDropdownValue = newDropdownValue.concat(West_IL_TX_NY_DC);
        }else if(event.value === "East (CA + IL/TX)"){
          new_state_list.push(...East_CA_IL_TX.map((state) => state.value));
          newDropdownValue = newDropdownValue.concat(East_CA_IL_TX);
        }else if(event.value === "West (CA + IL/TX)"){
          new_state_list.push(...West_CA_IL_TX.map((state) => state.value));
          newDropdownValue = newDropdownValue.concat(West_CA_IL_TX);
        }else if(event.value === "All Speakeasy States"){
          new_state_list.push(...All_SPEAKEASY_STATES.map((state) => state.value));
          newDropdownValue = newDropdownValue.concat(All_SPEAKEASY_STATES);
        }else {
          new_state_list.push(event.value);
          const selectedStateOption = retailer_assignment_overrides_states_list.find((option) => option.value === event.value);
          if (selectedStateOption) {
            newDropdownValue.push(selectedStateOption);
          }
        }
      });
  
      setselectedState(new_state_list);
      setselectedStateDropdownValue(newDropdownValue);
    }
  };

  const handleChannelChange = (selected) => {
    setselectedChannelDropdownValue(selected);
    var new_channel_list = [];
    selected.forEach((event) => {
      if (event.value === "__all__") {
        setselectedChannel("__all__");
      } else {
        new_channel_list.push(event.value);
        setselectedChannel(new_channel_list);
      }
    });
  };

  const getInventoryLocation = () => {
    api
      .get(`inventory-location-list/`)
      .then((response) => response)
      .then((response) => {
        if (response.status === 200) {
          setInventoryLocationlist(response.data);
        }
      })
      .catch((err) => {});
  };

  const handleNext = () => {
    if (data.next) {
      let results = data.results;
      setLoading(true);
      api
        .get(data.next)
        .then((response) => {
          const new_results = results.concat(response.data.results);
          setData({
            ...data,
            results: new_results,
            next: response.data.next,
            previous: response.data.previous,
          });
          setLoading(false);
        })
        .catch((error) => console.log(error));
    }
  };

  const handleSubmitForm = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    if (!inventory_location || !selectedState.length || !selectedProduct.length) {
      addToast('Missing required fields', { appearance: 'error', autoDismiss: true });
      return;
    }
    try {
      const response = await api.post("retailer-override-ui/", {
          inventory_location: inventory_location,
          state: selectedState,
          variant: selectedProduct,
          sales_channel: selectedChannel,
        })
      if (response.status === 201) {
        addToast(response.data.message, { appearance: 'success', autoDismiss: true });
        toggle();
        if (!formData) {
          setTimeout(() => window.location.reload(false), 1000);
        }
      }
    } catch (err) {
      const message = err.response?.data?.message || err.message || "Something went wrong, please try again!";
      addToast(message, { appearance: "error", autoDismiss: true });
      toggle();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="form-group mb-3 d-flex flex-column" data-field="name">
        <Modal
          style={{ marginTop: "100px" }}
          isOpen={isOpen}
          onExit={toggle}
          toggle={() => toggle()}
          size={"lg"}
        >
          <Form onSubmit={handleSubmitForm}>
            <ModalHeader toggle={toggle} className="bg-primary text-white">
              <span className="text-white h3">
                Retailer Assignment Overrides
              </span>
            </ModalHeader>
            <ModalBody>
              <FormGroup>
                <Row>
                  <Col>
                    <Label>Inventory Location *</Label>
                    <br />
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      value={
                        inventory_location
                          ? { value: inventory_location, label: inventory_location }
                          : null
                      }
                      options={InventoryLocation_list.map(({ name }) => ({
                        value: name,
                        label: name,
                      }))}
                      onChange={(selectedOption) =>
                        setInventory_location(selectedOption ? selectedOption.value : "")
                      }
                      placeholder="Select inventory location"
                      isClearable
                    />

                  </Col>
                  <Col>
                    <Label>State *</Label>
                    <CustomMultiSelectDropdown
                        onChangeHandler={handleChange}
                        options={retailer_assignment_overrides_states_list}
                        placeholder="Select one or multiple state(s)"
                        isValid={stateIsValid}
                        values={selectedStateDropdownValue}
                    />        
                  </Col>
                </Row>
                <Row>
                  <Col>
                      <Label>Sales Channel</Label>
                      <CustomMultiSelectDropdown
                          onChangeHandler={handleChannelChange}
                          options={OrderChannel_list}
                          placeholder="Select one or multiple channel(s)"
                          isValid={channelIsValid}
                          values={selectedChannelDropdownValue}
                      />        
                  </Col>
                </Row>
                <Label className="mt-3">Variant *</Label>
                <MDBCol style={{ display: "-webkit-box" }}>
                  <MDBIcon icon="search" className="mr-2 ml-0" />
                  <input
                    className="form-control form-control-sm"
                    onKeyDown={handleSearch}
                    type="text"
                    placeholder="Search"
                    aria-label="Search"
                  />
                </MDBCol>
                <ul
                  className={"p-2 overflow-auto"}
                  style={{ maxHeight: "300px" }}
                  id={"filter_"}
                >
                  {data.results.map((product) => (
                    <div key={product.id + "_prod_"}>
                      <div
                        key={product.id + "_product_"}
                        className="row my-2 d-flex align-items-center"
                        style={{ width: "40rem" }}
                      >
                        <div className="col-2 pr-0">
                          <Label className={"text-sm"}>
                            <input
                              type="checkbox"
                              id={"_" + product.id}
                              className={"checkbox_product"}
                              value={product.id}
                              data-label={product.name}
                              data-image={product.image}
                              defaultChecked={product.checked}
                              onChange={(e) =>
                                handleProductCheckbox(e, product.id)
                              }
                              style={{ marginRight: "20px" }}
                            />
                          </Label>
                          {product.image ? (
                            <img
                              src={product.image}
                              className="img-thumbnail rounded-0"
                              width="50%"
                            />
                          ) : (
                            <img
                              src="https://assets-barcart.s3.amazonaws.com/static/images/placeholder-bottle-and-glass.png"
                              className="img-thumbnail rounded-0"
                              width="50%"
                            />
                          )}
                        </div>
                        <div className="col-10">
                          <a
                            href={window.env.APP_URL + "product/" + product.id}
                            target="_blank"
                          >
                            <span className="text-wrap"> {product.name}</span>
                            <span
                              className="text-right"
                              style={{ paddingLeft: "10px", color: "black" }}
                            ></span>
                          </a>
                        </div>
                      </div>
                      {product.variants &&
                        product.variants.map((variant, index) => (
                          <div
                            className={"row sub-product ml-3"}
                            key={index + "_variant_"}
                          >
                            <div
                              className="col-2 pr-0 variant-container"
                              key={index}
                            >
                              <Label className={"text-sm"}>
                                <input
                                  type="checkbox"
                                  id={"_" + variant.id}
                                  className={"variant_" + product.id}
                                  value={variant.id}
                                  data-label={variant.sku}
                                  data-image={variant.image}
                                  // if variant sku from props and variant sku from api is same then checkbox is selected by default 
                                  defaultChecked={formData ? formData.variant.includes(variant.sku) : variant.checked}
                                  onChange={(e) =>
                                    handleVariantProductCheckbox(e, variant.id)
                                  }
                                  style={{ marginRight: "20px" }}
                                />
                              </Label>
                              {variant.image ? (
                                <img
                                  src={variant.image}
                                  className="img-thumbnail rounded-0"
                                  width="50%"
                                />
                              ) : (
                                <img
                                  src="https://assets-barcart.s3.amazonaws.com/static/images/placeholder-bottle-and-glass.png"
                                  className="img-thumbnail rounded-0"
                                  width="50%"
                                />
                              )}
                            </div>
                            <a href={void 0}>
                              {variant?.size_title === null ?
                                <span className="text-wrap">{`${variant.sku}`}</span>
                                :
                                <span className="text-wrap">{`${variant.size_title} - ${variant.sku}`}</span>
                              }
                              <span
                                className="text-right"
                                style={{ color: "black" }}
                              ></span>
                            </a>
                          </div>
                        ))}
                    </div>
                  ))}

                  {data.results.length < data.count && (
                    <li className={"text-center"}>
                      {!isLoading ? (
                        <Button className={"btn btn-sm "} onClick={handleNext}>
                          show more
                        </Button>
                      ) : (
                        <span className={"text-sm text-muted"}>Loading...</span>
                      )}
                    </li>
                  )}
                </ul>
              </FormGroup>
            </ModalBody>
            <ModalFooter className="mt-0 pt-0">
              <Button color="secondary" onClick={toggle}>
                Cancel
              </Button>
              <Button color="primary" id="save_btn" onClick={handleSubmitForm} disabled={!!isSubmitting}>
                Save
                {!!isSubmitting && <Spinner size="sm" color="light" />}
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
      </div>
    </>
  );
}
